<template>
  <ElIcons v-if="userRow.ipState== 1 || userRow.ipState == 2" :color="userRow.ipState == 1?'red':'#67c23a'" name="WarningFilled" size="16" style="cursor: pointer; margin-left: 4px;" @click="openIpCityDialog()"/>
</template>

<script>
import ipCityAbnormalDialog from "@/components/resume/ipCityAbnormalDialog";
import Dialog from "@/assets/js/dialog";
export default {
  name: "ipCityAbnormal",
  props: {
    row: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      userRow: this.row,
    }
  },
  watch: {
    row() {
      this.userRow = this.row;
    }
  },
  methods: {
    //用户异常ip列表
    openIpCityDialog() {
      Dialog.open({
        title: '用户【' + this.userRow.nickName + '】异常ip列表',
        component: ipCityAbnormalDialog,
        data: {
          id: this.userRow.userId,
          width: '600px',
          ipState: this.userRow.ipState,
        },
        confirm: (result) => {
          this.userRow['ipState'] = result.state
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
